// import $ from 'jquery'

export default {
    name: 'add-analyse',
    components: {},
    props: ["protocole_id", "consultation_id", "is_new_bulletin", "edit_bulletin", "jn"],
    data() {
        return {
            loading: false,
            save_loading: false,

            choix_type_demande: '',
            can_show_analyse: false,

            renseignement_clinique: '',

            can_save: false,
            choice_is_empty: false,
            selected_analyse: [],

            existing_analyses: [],
            sv_loading: false,
        }
    },

    watch: {
        edit_bulletin() {
            this.renseignement_clinique = this.edit_bulletin.renseignement_clinique
        }
    },

    computed: {
        categoriesAnalyses() {
            return this.$store.getters["categoriesAnalyses"];
        },

        types_examens() {
            return this.$store.getters["examens"];
        },
    },

    mounted() {
        this.$store.dispatch("getCategoriesAnalyses")
        this.$store.dispatch("getExamens");
    },

    methods: {
        onChoice(value) {
            if (value == 1) {
                this.can_show_analyse = true
            } else {
                this.can_show_analyse = false
            }
            
        },

        checkIfExistInBulletin() {
            this.edit_bulletin.analyses.forEach(sl => {
                var bull = this.selected_analyse.filter((el) => {
                    return el.id != sl.analyse_id
                })

                this.selected_analyse = bull
            });
        },

        toggleRenseignement(v) {
            if (v) {
                if (this.selected_analyse.length == 0) {
                    this.choice_is_empty = true
                    return
                }
            }

            this.can_save = v
        },

        clearError() {
            this.choice_is_empty = false
        },

        //Request pour demander une analyse
        demandeAnalyse() {
            if (!this.is_new_bulletin) {
                /**
                 * Deselectionner les analyse déjà existantes
                 */
                this.checkIfExistInBulletin()
            }

            this.choice_is_empty = false
            
            let data = {
                consultation_id: this.consultation_id,
                protocole_id: this.protocole_id,
                analyses: this.selected_analyse,
                user_id: this.$store.getters["authInfo"].id,
                choix_type_demande: this.choix_type_demande,
                renseignement_clinique: this.renseignement_clinique,
                bulletin_id: this.edit_bulletin.bulletin_id
            }

            if (data.analyses.length == 0) {
                return
            }

            if (this.is_new_bulletin && this.renseignement_clinique == '') {
                return 
            }

            this.loading = true
            console.log(data)

            this.$store.dispatch('saveDemandeAnalyseForHn', data).then((response) => {
                if (response > 0) {
                    this.successToast("Demande d'analyse ajoutée avec succès")

                    this.renseignement_clinique = ''
                    this.selected_analyse = []
                    this.can_save = false

                    this.$emit('emitProtocole', this.jn)
                    this.$refs.analyseModal.click();
                }
                this.loading = false
            })
        }, 

        async submit() {
            const isValid = await this.$refs.r_form.validate();

            if (!isValid) {
                return;
            }

            this.sv_loading = true

            let data = {
                bulletin_id: this.edit_bulletin.bulletin_id,
                renseignement_clinique: this.renseignement_clinique
            }

            this.$store.dispatch('editRenseignementClinique', data).then((response) => {
                if (response > 0) {
                    this.renseignement_clinique = ''
                    this.$refs.r_form.reset()
                    this.$refs.edit_renseign.click()

                    this.$emit('emitProtocole', this.jn)
                }

                this.sv_loading = false
            })
        }
    }
}